import ProcessFlowActivityNode from "./nodes/ActivityNode";
import ProcessFlowGatewayNode from "./nodes/GatewayNode";
import ProcessFlowStartNode from "./nodes/StartNode";
import ProcessFlowEndNode from "./nodes/EndNode";
import ProcessFlowSwimlaneNode from "./nodes/SwimlaneNode";
import ProcessFlowViralPlaceholderNode from "./nodes/ViralPlaceholderNode";
import ProcessFlowEventNode from "./nodes/EventNode";
import ProcessFlowStickyNoteNode from "./nodes/StickyNoteNode";
import ProcessFlowEmptyStepPlaceholderNode from "./nodes/EmptyStepPlaceholderNode";
import ProcessFlowEdge from "./edges/FlowEdge";
import NoteConnectorEdge from "./edges/NoteConnectorEdge";
const nodeTypes = {
    flowStart: ProcessFlowStartNode,
    flowEnd: ProcessFlowEndNode,
    flowGateway: ProcessFlowGatewayNode,
    flowActivity: ProcessFlowActivityNode,
    flowSwimlane: ProcessFlowSwimlaneNode,
    flowViralPlaceholder: ProcessFlowViralPlaceholderNode,
    flowEvent: ProcessFlowEventNode,
    flowNote: ProcessFlowStickyNoteNode,
    flowEmptyStep: ProcessFlowEmptyStepPlaceholderNode
};
const edgeTypes = {
    default: ProcessFlowEdge,
    noteConnector: NoteConnectorEdge
};
export const PROCESS_FLOW_REGISTRY = {
    nodeTypes,
    edgeTypes
};

//# sourceMappingURL=registry.js.map